export default __webpack_public_path__ + "static/summer-sale-overlay-27a1bb6d0c90113d982c20f405dce09b.png";